import { observable, computed, makeAutoObservable } from 'mobx';
import * as t from 'io-ts';
import { createGuard } from 'src_common/common/createGuard';
import { reduxImmutableHash } from './utils/reduxImmutableHash';
import { ReduxRawState } from './utils/ReduxRawState';

const FreebetCreditsIO = t.record(
    t.string,
    t.interface({
        data: t.union([
            t.undefined,
            t.null,
            t.interface({
                bonusCredits: t.array(t.unknown),
                totalAmount: t.number,
            }),
        ]),
    })
);

const CustomersIO = t.interface({
    freebetCredits: FreebetCreditsIO,
});

const isCustomers = createGuard(CustomersIO);

type CustomersDataType = t.TypeOf<typeof CustomersIO>;
type FreebetCreditsType = t.TypeOf<typeof FreebetCreditsIO>;

export class ReduxCustomerState {
    @observable private customersData: CustomersDataType | null = null;

    public constructor(reduxStore: ReduxRawState) {
        reduxImmutableHash(
            reduxStore,
            (state: Record<string, unknown>): unknown => state.customers,
            (data: unknown): void => {
                if (data === undefined) {
                    return;
                }

                if (isCustomers(data)) {
                    this.customersData = data;
                } else {
                    console.error('ReduxCustomerState -> incorrect data', data);
                }
            }
        );
        makeAutoObservable(this);
    }

    @computed public get customersDataForView(): CustomersDataType | null {
        return this.customersData;
    }
    @computed public get freebetCredits(): FreebetCreditsType {
        return this.customersData?.freebetCredits ?? {};
    }
}
